module.exports = __webpack_public_path__ + "static/media/zheng9@2x.9ca2162b.png";